module.exports = __webpack_public_path__ + "static/img/43.62177cf1.gif";